import { ReactSession } from 'react-client-session';

/**
 * Get the token from the localStorage
 * @returns Token
 */
export const getLocalToken = ()=>{
    const token = ReactSession.get("csmit_token");
    return token;
}

/**
 * Method that used to store the token data
 * @param {Object} tokenData - New token data
 */
export const UpdateLocalAccessToken = (tokenData)=>{
    const { token, tokenExpiresIn} = tokenData;
    //Saving token to the local storage
    ReactSession.set("csmit_token", token);
    //Save the token expires
    ReactSession.set('csmit_tokenExpiresIn',tokenExpiresIn);
}

/**
 * Used to store user data into the localstorage
 * @param {Object} userData User data object
 */
export const UpdateLocalProfile = (userData)=>{
    //Saving data to the local storage
    ReactSession.set("csmit_userdata", JSON.stringify(userData));
}

export const getLocalProfile = ()=>{
    //Get data from the local storage
    return ReactSession.get("csmit_userdata");
}

/**
 * Used to remove all localstorage data
 */
export const RemoveAllLocalData = ()=>{
    ReactSession.remove("csmit_userdata");
    ReactSession.remove("csmit_token");
    ReactSession.remove("csmit_tokenExpiresIn");
    ReactSession.remove("permitted_routes");
    ReactSession.remove("permissions");
    ReactSession.remove("permittedSubmenus");
    ReactSession.remove("user_profile_route");
}

export const UpdateLocalRoutes = (routes)=>{
    ReactSession.set('permitted_routes',routes);
}

export const getLocalRoutes = ()=>{
    return ReactSession.get('permitted_routes');
}

export const UpdateLocalPermission = (permission)=>{
    ReactSession.set('permissions',permission);
}

/**
 * Function used to store submenus as route in the localstorage
 * @param {Object} submenus Object of submenus
 */
export const UpdateLocalSubmenus = (submenus)=>{
    ReactSession.set('permittedSubmenus',submenus);
}

export const getLocalSubmenus = ()=>{
    return ReactSession.get('permittedSubmenus');
}

export const getLocalAccessPermisions = ()=>{
    return ReactSession.get('permissions');
}

export const UpdateUserProfile = (route)=>{
    ReactSession.set('user_profile_route',route);
}

export const getUserProfile = ()=>{
    return ReactSession.get('user_profile_route');
}